


























import { format } from 'date-fns';
import { BButton } from 'bootstrap-vue';
import ScheduleMessage from './ScheduleMessage.vue';
import { DATE_FORMAT, RecurrenceTypes } from './utils';
import { buildForm } from './suggestions';

export default {
  name: 'RecurrenceInfo',
  components: {
    ScheduleMessage,
    BButton,
  },
  props: {
    objectTitle: {
      type: String,
      default: '',
    },
    csrfToken: {
      type: String,
      required: true,
    },
    recApiUrl: {
      type: String,
      required: true,
    },
    scheduleData: {
      type: Array,
      default() {
        return [];
      },
    },
    objectType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        startDate: format(new Date(), DATE_FORMAT),
        endDate: null,
        repeatOption: null,
        stopRepeating: null,
        stopOn: null,
        repeatOn: null,
        repeatTimes: 1,
        repeatInterval: 1,
        period: null,
      },
    };
  },
  computed: {
    rule() {
      return this.scheduleData.find(field => field.name === 'rule');
    },
    recurrenceType() {
      const recType = this.scheduleData.find(field => field.name === 'recurrenceType');
      if (recType) {
        return recType.value;
      }

      return RecurrenceTypes.Legacy;
    },
  },
  created() {
    this.init();
  },
  methods: {
    setSchedule() {
      // here will pass the parsed form for initialization
      const data = {
        type: this.objectType,
        csrfToken: this.csrfToken,
        recApiUrl: this.recApiUrl,
        scheduleData: this.scheduleData,
        objectTitle: this.objectTitle,
      };

      window.GGRC.zenModal.show({
        type: 'NewRecurrenceModal',
        data,
        config: { ignoreUrl: true },
      });
    },
    init() {
      if (!this.rule) return;

      const startsOn = this.scheduleData.find(field => field.name.toLowerCase().includes('starts on'));
      const dueOn = this.scheduleData.find(field => field.name.toLowerCase().includes('due on'));

      const scheduleData = {
        startDate: startsOn && startsOn.viewModel ? startsOn.viewModel.value : null,
        dueOn: dueOn && dueOn.viewModel ? dueOn.viewModel.value : null,
        recurrenceType: this.recurrenceType,
        rule: this.rule,
      };

      this.form = buildForm(scheduleData);
    },
  },
};
